export default import.meta.ROLLDOWN_FILE_URL_DNp5H297c$xV42a1l6t5aA